/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ILP Content Delivery API
 * API for delivering educational content including course structures and glossaries
 * OpenAPI spec version: v1
 */
import useSwr from "swr";
import type { Key, SWRConfiguration } from "swr";

import useSWRMutation from "swr/mutation";
import type { SWRMutationConfiguration } from "swr/mutation";

import type {
  CreateLearningProgressRequest,
  Error,
  LearningProgress,
  ValidationErrors,
} from "../model";

import { apiFetch } from "../../apiFetch";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getListLearningProgressesUrl = (enrollmentId: string) => {
  return `/api/v1/enrollments/${enrollmentId}/learning_progresses`;
};

/**
 * Retrieves all learning progress records for a specific enrollment
 * @summary List learning progresses for an enrollment
 */
export const listLearningProgresses = async (
  enrollmentId: string,
  options?: Parameters<typeof apiFetch>[1]
): Promise<LearningProgress[]> => {
  return apiFetch<LearningProgress[]>(
    getListLearningProgressesUrl(enrollmentId),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getListLearningProgressesKey = (enrollmentId: string) =>
  [`/api/v1/enrollments/${enrollmentId}/learning_progresses`] as const;

export type ListLearningProgressesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLearningProgresses>>
>;

/**
 * @summary List learning progresses for an enrollment
 */
export const useListLearningProgresses = <TError = Error>(
  enrollmentId: string,
  options?: {
    swr?: SWRConfiguration<
      Awaited<ReturnType<typeof listLearningProgresses>>,
      TError
    > & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof apiFetch>;
  }
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const isEnabled =
    swrOptions?.enabled !== false &&
    enrollmentId !== null &&
    enrollmentId !== undefined;
  const swrKey =
    swrOptions?.swrKey ??
    (() => (isEnabled ? getListLearningProgressesKey(enrollmentId) : null));
  const swrFn = () => listLearningProgresses(enrollmentId, requestOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(
    swrKey,
    swrFn,
    swrOptions
  );

  return {
    swrKey,
    ...query,
  };
};
export const getCreateLearningProgressUrl = (enrollmentId: string) => {
  return `/api/v1/enrollments/${enrollmentId}/learning_progresses`;
};

/**
 * Creates a new learning progress or updates an existing one (upsert by content_element_id). Auto-increments attempts on update.
 * @summary Create or update a learning progress
 */
export const createLearningProgress = async (
  enrollmentId: string,
  createLearningProgressRequest?: CreateLearningProgressRequest,
  options?: Parameters<typeof apiFetch>[1]
): Promise<LearningProgress> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string]
        )
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return apiFetch<LearningProgress>(
    getCreateLearningProgressUrl(enrollmentId),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(createLearningProgressRequest),
    }
  );
};

export const getCreateLearningProgressMutationFetcher = (
  enrollmentId: string,
  options?: SecondParameter<typeof apiFetch>
) => {
  return (
    _: Key,
    { arg }: { arg: CreateLearningProgressRequest | undefined }
  ) => {
    return createLearningProgress(enrollmentId, arg, options);
  };
};
export const getCreateLearningProgressMutationKey = (enrollmentId: string) =>
  [`/api/v1/enrollments/${enrollmentId}/learning_progresses`] as const;

export type CreateLearningProgressMutationResult = NonNullable<
  Awaited<ReturnType<typeof createLearningProgress>>
>;

/**
 * @summary Create or update a learning progress
 */
export const useCreateLearningProgress = <TError = Error | ValidationErrors>(
  enrollmentId: string,
  options?: {
    swr?: SWRMutationConfiguration<
      Awaited<ReturnType<typeof createLearningProgress>>,
      TError,
      Key,
      CreateLearningProgressRequest | undefined,
      Awaited<ReturnType<typeof createLearningProgress>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof apiFetch>;
  }
) => {
  const { swr: swrOptions, request: requestOptions } = options ?? {};

  const swrKey =
    swrOptions?.swrKey ?? getCreateLearningProgressMutationKey(enrollmentId);
  const swrFn = getCreateLearningProgressMutationFetcher(
    enrollmentId,
    requestOptions
  );

  const query = useSWRMutation(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};
